import { ChangeDetectionStrategy, Component, inject, input, model, OnInit, output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { SdButtonIconComponent } from '../buttons/button-icon/button-icon.component';
import { SdModalAsideComponent } from '../modals/modal-aside/modal-aside.component';
import { SdThemeComponent } from '../abstract/theme/theme.component';
import { PositionEnum } from '../../_enums/position.enum';
import { IconSizeEnum } from '../../_enums/icon.enum';
import { SdHtmlComponent } from '../html/html.component';
import { SectionService } from '@seb/web-design-system/core/src/lib/_services/section.service';
import { SectionTypeEnum } from '@seb/web-design-system/core';

@Component({
  selector: 'sd-section',
  templateUrl: './section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdHtmlComponent,
    SdModalAsideComponent,
    SdButtonIconComponent,
    NgTemplateOutlet
  ]
})
export class SdSectionComponent extends SdThemeComponent implements OnInit {
  title = input('');
  isOpened = model(false);
  type = input<SectionTypeEnum>();

  sectionService = inject(SectionService);

  isOpenedChange = output<boolean>();

  PositionEnum = PositionEnum;
  IconSizeEnum = IconSizeEnum;

  ngOnInit() {
    this.sectionService.onClickSection().subscribe((type: SectionTypeEnum) => {
      if (this.type() === type) {
        this.onClick();
      }
    });
  }

  onClick(): void {
    this.isOpened.set(true);
  }
}
